import React, { Component, createRef } from "react";
import { Text, View } from "react-native";

export default class CameraController extends Component {
  state = { permission: P.ASK };
  video = createRef();
  canvas = createRef();
  stream = null;
  mediaRecorder = null;
  // on unmount we explicitly need to stop tracks for browser recording icon to disappear
  videoTracks = [];
  audioTracks = [];

  componentDidMount = () => {
    this.setup();
  };

  setup = () => {
    const constraints = {
      audio: true,
      video: true,
    };
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(stream => {
        this.setState({ permission: P.GRANTED });
        this.props.onPermissionGranted();
        this.videoTracks = stream.getVideoTracks();
        this.audioTracks = stream.getAudioTracks();
        this.video.current.onloadedmetadata = () => this.video.current.play();
        this.video.current.srcObject = this.stream = stream;
      })
      .catch(() => this.setState({ permission: P.DENIED }));
  };

  teardown = () => {
    this.videoTracks.forEach(track => track.stop());
    this.audioTracks.forEach(track => track.stop());
  };

  takePictureAsync = () => {
    return new Promise(resolve => {
      this.canvas.current.width = this.video.current.videoWidth;
      this.canvas.current.height = this.video.current.videoHeight;
      this.canvas.current.getContext("2d").drawImage(this.video.current, 0, 0);
      this.canvas.current.toBlob(image => {
        const imageURL = window.URL.createObjectURL(image);
        resolve(imageURL);
      }, "image/png");
    });
  };

  recordAsync = () => {
    const videoChunks = [];
    this.mediaRecorder = new window.MediaRecorder(this.stream);
    this.mediaRecorder.ondataavailable = e => videoChunks.push(e.data);
    this.mediaRecorder.start();
    this.mediaRecorder.onstop = () => {
      const blob = new window.Blob(videoChunks, { type: "video/mp4" });
      const recordedVideo = window.URL.createObjectURL(blob);
      this.props.getRecordedVideo(recordedVideo);
    };
  };

  stopRecording = () => this.mediaRecorder.stop();

  componentWillUnmount = () => this.teardown();

  renderPermissionError = () => {
    return <Text style={styles.error}>Please allow camera access</Text>;
  };

  renderCamera = () => {
    return (
      <>
        <canvas ref={this.canvas} style={{ display: "none" }} />
        <video muted ref={this.video} style={{ backgroundColor: "black" }} />
      </>
    );
  };

  render = () => {
    return (
      <View style={[{ flex: 1 }]}>
        {this.state.permission === P.GRANTED
          ? this.renderCamera()
          : this.renderPermissionError()}
        {this.props.children}
      </View>
    );
  };
}

const P = {
  ASK: "A",
  GRANTED: "G",
  DENIED: "D",
};

const styles = {
  error: {
    backgroundColor: "black",
    color: "white",
    fontSize: 18,
    padding: 20,
  },
};
